import Vue from 'vue'
import DataBar from '../data/DataBar.vue'
import DataPie from '../data/DataPie.vue'
import VueI18n from 'vue-i18n'
import BootstrapVue from 'bootstrap-vue'

Vue.use(VueI18n)
Vue.use(BootstrapVue)

const locale = gon.i18n.locale || this.config.i18n.locale
const i18n = new VueI18n({
  locale,
  messages: {[locale]: gon.i18n.translations || this.config.i18n.translations}
})

document.addEventListener('DOMContentLoaded', () => {
  const elements = ['units', 'tokens']

  const precision = parseInt(i18n.t('ncs.number.format.precision'))
  const delimiter = i18n.t('ncs.number.format.delimiter') === '&nbsp;' ? ' ' : i18n.t('ncs.number.format.delimiter')
  const separator = i18n.t('ncs.number.format.separator')

  elements.forEach(e => {
    const el = document.getElementById(`corpus-${e}`)
    const props = {
      i18nKeyPrefix: `pages.data.corpus_short`,
      data: gon.corpus[e],
      precision,
      delimiter,
      separator,
      rotateAlways: true
    }
    new Vue({i18n, el, render: h => h(DataBar, {props})})
  })
  elements.forEach(e => {
    new Vue({
      i18n,
      el: document.getElementById(`${e}-ncs_documents.text_genre`),
      render: h => h(DataBar, {
        props: {
          i18nKeyPrefix: `ncs.result.full_frequency.ncs_documents.text_genre.values`,
          data: gon[e]['ncs_documents.text_genre'],
          precision,
          delimiter,
          separator
        }
      })
    })
    new Vue({
      i18n,
      el: document.getElementById(`${e}-ncs_documents.specialization`),
      render: h => h(DataPie, {
        props: {
          i18nKeyPrefix: `ncs.result.full_frequency.ncs_documents.specialization.values`,
          data: gon[e]['ncs_documents.specialization'],
          precision,
          delimiter,
          separator
        }
      })
    })
    new Vue({
      i18n,
      el: document.getElementById(`${e}-ncs_documents.language`),
      render: h => h(DataPie, {
        props: {
          i18nKeyPrefix: `ncs.result.full_frequency.ncs_documents.language.values`,
          data: gon[e]['ncs_documents.language'],
          precision,
          delimiter,
          separator
        }
      })
    })
  })
})
